import PropTypes from 'prop-types';
import React from 'react';
import styles from './AddToCalendarDesktop.scss';
import classNames from 'classnames';
import X from 'wix-style-react/new-icons/X';
import Dropdown from 'wix-style-react/Dropdown';
import Modal from 'wix-style-react/Modal';
import generateAddToCalendarHref from '../../utils/calendarUtils';
import {Link} from 'react-router';

export class CancelReservation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: 'google',
      customComment: ''
    };
  }

  handleHrefClick(event, href, download) {
    if (download && window.navigator.msSaveBlob) {
      event.preventDefault();
      window.navigator.msSaveBlob(new Blob([decodeURI(href.replace('data:text/calendar;charset=utf8,', ''))]), download);
    }
  }

  render() {
    const {i18n, reservation, organization} = this.props;
    const direction = i18n.isRtlDir() ? 'rtl' : 'ltr';
    const options = [
      {id: 'google', value: 'Google Calendar'},
      {id: 'ical', value: 'iCalendar'},
      {id: 'outlook', value: 'Outlook'},
    ];
    const {href, download, target} = generateAddToCalendarHref(reservation, organization, this.state.type);

    return (
      <Modal
        isOpen
        contentLabel={'contentLabel'}
        shouldCloseOnOverlayClick
        onRequestClose={() => this.props.router.push(this.props.home)}
        >
        <div className={styles.addToCalendar} style={{direction}} data-hook="add-to-calendar">
          <div className={styles.closeButton} data-hook={'close'}>
            <Link className={classNames(styles.button, styles.backButton, styles.xButton)} to={this.props.home}>
              <span className={styles.closeButtonInner}>
                <X className={styles.closeButtonSvg}/>
              </span>
            </Link>
          </div>
          <div className={styles.title} data-hook={'title'}>{i18n.get('modify_reservation_add_to_calendar', 'Add To Calendar')}</div>
          <div className={styles.subTitle} data-hook={'description'}>{i18n.get('modify_reservation_add_to_calendar_sub_title', 'Add to celendar subtitle')}</div>
          <div className={styles.dropdown + ' ' + direction} data-hook={'choose-calendar'}>
            <Dropdown
              selectedId={this.state.type}
              options={options}
              placeholder={i18n.get('modify_reservation_choose_calendar_type', 'Choose calendar type...')}
              onSelect={option => this.setState({type: option.id})}
              />
          </div>
          <div className={classNames(styles.divider, styles.bottomDivider)}/>
          <div className={styles.buttons}>
            <Link
              className={classNames(styles.button, styles.backButton)}
              to={this.props.home}
              data-hook="back"
              >
              {i18n.get('modify_reservation_back', 'Back')}
            </Link>
            <a
              onClick={event => this.handleHrefClick(event, href, download)}
              href={href}
              target={target}
              download={download}
              rel="noopener noreferrer"
              className={classNames(styles.button, styles.addToCalendarButton)}
              data-hook="add"
              >
              {i18n.get('modify_reservation_add_to_calendar', 'Add To Calendar')}
            </a>
          </div>
        </div>
      </Modal>
    );
  }
}

CancelReservation.displayName = 'AddToCalendarDesktop';
CancelReservation.propTypes = {
  i18n: PropTypes.object,
  reservation: PropTypes.object,
  organization: PropTypes.object,
  onCancel: PropTypes.func,
  setReservationStatusRequest: PropTypes.func,
  home: PropTypes.string,
  router: PropTypes.shape({
    push: PropTypes.func
  })
};

export default CancelReservation;



// WEBPACK FOOTER //
// ./components/AddToCalendarDesktop/AddToCalendarDesktop.js